/**
 * [回到顶部]
 */
var $backToTopEle = $('.btn-top').click(function() {
    $('html, body').animate({
        scrollTop: 0
    }, 120);
});

$(window).bind('scroll', function() {
    var st = $(document).scrollTop();
    if (st > 0) {
        $backToTopEle.css('display', 'block');
    } else {
        $backToTopEle.css('display', 'none');
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/component/backtotop.js
// module id = 1
// module chunks = 0